export const InvitationFailedModal: string = 'InvitationFailedModal';
